export default __webpack_public_path__ + "static/media/icon_acceleration.2add260f.svg";